// 导出提示消息相关的工具方法
export * from './tips';

// 获取taskId 数据类型转换
export function getTaskId(taskId: string): number | null {
  const taskIdTemp = Number.parseInt(decodeURIComponent(taskId), 10);
  return Number.isNaN(taskIdTemp) ? null : taskIdTemp;
}

// 保存文件流到本地
export function saveFile2Local(blobPart: BlobPart, type: string, fileName: string) {
  const blob = new Blob([blobPart], { type });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', fileName);
  a.click();
  window.URL.revokeObjectURL(url);
}
